import { Helmet } from "react-helmet-async";

const SITE_NAME = "Maternnia";
const DEFAULT_DESC =
  "A Maternnia reúne orientação confiável, profissionais cuidadosamente selecionados e recursos para ajudar mulheres e famílias a fazer escolhas mais conscientes em cada fase da maternidade.";
const DEFAULT_IMAGE = "/maternnia-logo-dark.png";

export const Seo = ({
  title,
  description = DEFAULT_DESC,
  path,
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  jsonLd,
}) => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const currentPath = path ?? (typeof window !== "undefined" ? window.location.pathname : "");
  const url = `${origin}${currentPath}`;
  const fullTitle = title ? `${title} • ${SITE_NAME}` : "Maternnia | Informação e profissionais para planejamento, gestação, parto e pós-parto";
  const absImage = image.startsWith("http") ? image : `${origin}${image}`;

  return (
    <Helmet>
      <html lang="pt-BR" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={absImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absImage} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
